import Vue from 'vue';
import Router from 'vue-router';

const routes: Array<any> = [];

Vue.use(Router);

const Unsubscribes: any = () => import('@/layouts/Unsubscribes.vue');
const EmailPreferences: any = () => import('@/layouts/EmailPreferences.vue');
const Error: any = () => import('@/layouts/Error.vue');

routes.push(
  { path: '/unsubscribe', component: Unsubscribes, meta: { auth: true, title: 'Unsubscribe page' } },
  { path: '/email-preference', component: EmailPreferences, meta: { auth: true, title: 'Email Preference page' } },
  { path: '/*', component: Error, name: 'error' },
  { path: '/error', component: Error, name: 'error' },
);

export default new Router({
  mode: 'history',
  routes,
});
